export default function PageNotFound() {
    return (
        <div id="page not found">
            Page Not Found
        </div>
    );
}
